export default {
  checkMarkTextFontSize: '0.8rem',
  acceptNewsLetterMargin: '0',
};
